import { render, staticRenderFns } from "./CustomLabel.vue?vue&type=template&id=bfe36d54&scoped=true&lang=true"
import script from "./CustomLabel.vue?vue&type=script&lang=js"
export * from "./CustomLabel.vue?vue&type=script&lang=js"
import style0 from "./CustomLabel.vue?vue&type=style&index=0&id=bfe36d54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfe36d54",
  null
  
)

export default component.exports